module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.c1d289e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_lets-get_768.png
// module id = 6rOQ
// module chunks = 0